import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-toolbox/lib/button';
import CSSModules from 'helpers/CSSModulesUtil'

import styles from './styles.scss'

const ButtonComponent = ({ onClick, label, icon }) => (
  <Button
    primary
    raised
    theme={styles}
    icon={icon}
    onClick={onClick}
    label={label}
  />
)

export default ButtonComponent
